module.exports = __webpack_public_path__ + "static/media/regular.c3290f48.png";


//////////////////
// WEBPACK FOOTER
// ./src/public/images/SSP/regular.png
// module id = 251
// module chunks = 0